import { CallOutMenuItems, SubmissionPeriod, PayPeriodResponse } from '../models/enhancement'
import { EnhancementApprovalViewResponse } from '../models/enhancement/enhancement-approval-view-response'
import { EnhancementsRequestTypeConfigResponse } from '../models/enhancement/EnhancementsRequestTypeConfigResponse'

import { httpServiceV2 } from './httpServiceV2'

const requestsBaseURL = 'v2/enhancements'

export const enhancementService = {
  getApprovals: async (
    params?: SubmissionPeriod,
    employeeIds?: number[]
  ): Promise<EnhancementApprovalViewResponse> => {
    let requestURL = `${requestsBaseURL}/approvals`

    const queryParams = []

    if (params?.year) {
      queryParams.push(`year=${params.year}`)
    }

    if (params?.period) {
      queryParams.push(`period=${params.period}`)
    }

    if (employeeIds && employeeIds.length > 0) {
      employeeIds.forEach(id => {
        queryParams.push(`EmployeeIds=${id}`)
      })
    }

    if (queryParams.length > 0) {
      requestURL += `?${queryParams.join('&')}`
    }

    return httpServiceV2.get(requestURL)
  },

  postApprovalsSubmit: async (enhancementIds: number[]): Promise<EnhancementApprovalViewResponse> =>
    httpServiceV2.post(`${requestsBaseURL}/approvals/submitSelected`, { enhancementIds }),

  getCurrentPayPeriod: async (employeeId?: number): Promise<PayPeriodResponse> => {
    const query = employeeId !== undefined ? `?employeeId=${employeeId}` : ''
    return httpServiceV2.get(`${requestsBaseURL}/currentperiod${query}`)
  },

  getCallOutMenuItems: async (): Promise<CallOutMenuItems> =>
    httpServiceV2.get(`${requestsBaseURL}/callout/menuitems`),

  getRequestTypeConfig: async (): Promise<EnhancementsRequestTypeConfigResponse> =>
    httpServiceV2.get(`${requestsBaseURL}/requesttypeconfig`),
}
